import React, { useState } from 'react';
import { FeatureSidebarButton } from '@lmt/signal-viewer-ui';

type SplitScreenButtonProps = {
  defaultChecked?: boolean;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
};

const SplitScreenIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      aria-hidden='true'
    >
      <path
        d='M15 11C16.1045 11 16.9999 11.8955 17 13V14C17 15.0356 16.2128 15.887 15.2041 15.9893L15 16H5L4.7959 15.9893C3.85436 15.8938 3.1062 15.1456 3.01074 14.2041L3 14V13C3.00013 11.8955 3.89551 11 5 11H15ZM5 12C4.4478 12 4.00013 12.4478 4 13V14C4 14.5523 4.44772 15 5 15H15C15.5523 15 16 14.5523 16 14V13C15.9999 12.4478 15.5522 12 15 12H5ZM18.5 9C18.7761 9 18.9999 9.22397 19 9.5C19 9.77614 18.7761 10 18.5 10H1.5C1.22386 10 1 9.77614 1 9.5C1.00013 9.22397 1.22394 9 1.5 9H18.5ZM15 3C16.1045 3 16.9999 3.89554 17 5V6C17 7.03564 16.2128 7.88698 15.2041 7.98926L15 8H5L4.7959 7.98926C3.85436 7.89379 3.1062 7.14565 3.01074 6.2041L3 6V5C3.00013 3.89554 3.89551 3 5 3H15ZM5 4C4.4478 4 4.00013 4.44783 4 5V6C4 6.55228 4.44772 7 5 7H15C15.5523 7 16 6.55228 16 6V5C15.9999 4.44783 15.5522 4 15 4H5Z'
        fill='currentColor'
      />
    </svg>
  );
};

export const SplitScreenButton: React.FC<SplitScreenButtonProps> = ({
  defaultChecked = false,
  checked,
  onChange,
}) => {
  const [internalChecked, setInternalChecked] = useState(defaultChecked);

  const isControlled = checked !== undefined;
  const isChecked = isControlled ? checked : internalChecked;

  const handleClick = () => {
    const nextValue = !isChecked;

    if (!isControlled) {
      setInternalChecked(nextValue);
    }

    onChange?.(nextValue);
  };

  return (
    <FeatureSidebarButton
      icon={<SplitScreenIcon />}
      label='Split screen'
      active={isChecked}
      aria-pressed={isChecked}
      onClick={handleClick}
    />
  );
};
